import React from 'react';

const TRUST_ITEMS = [
  { label: 'PIPEDA', sub: 'Privacy Compliant' },
  { label: 'AES-256', sub: 'Data Encrypted' },
  { label: '2FA', sub: 'Auth Protection' },
  { label: 'EN / FR', sub: 'Bilingual' },
  { label: 'Open Beta', sub: 'Join Free' },
];

const TrustBanner = () => (
  <section className="py-12 bg-slate-900 border-t border-slate-800">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-green-900/40 border border-green-700/50 rounded-xl flex items-center justify-center">
            <svg className="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div>
            <p className="text-white font-semibold text-sm">Designed for Canadian Businesses</p>
            <p className="text-slate-400 text-xs">PIPEDA Compliant · Built on Emergent.sh · Encrypted at Rest</p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          {TRUST_ITEMS.map(({ label, sub }) => (
            <div key={label} className="text-center">
              <p className="text-white text-sm font-bold">{label}</p>
              <p className="text-slate-500 text-xs">{sub}</p>
            </div>
          ))}
        </div>
        <a
          href="/trust"
          className="shrink-0 text-xs text-green-400 hover:text-green-300 border border-green-700/50 px-4 py-2 rounded-lg transition-colors"
        >
          View Trust Center
        </a>
      </div>
    </div>
  </section>
);

export default TrustBanner;
